// extracted by mini-css-extract-plugin
export default {"container":"qK-z","topReviewHeading":"rK-z","criticalReview":"sK-z","favorableReview":"tK-z","vsSeparator":"uK-z"};